import { IInputCodeModalProps } from 'props';
import styled from 'styled-components';

export const Container = styled.div<IInputCodeModalProps>`
  display: flex;
  gap: 0.5rem;
  flex-direction: ${({ renderErrorOnRow }) => (renderErrorOnRow ? 'row' : 'column')};
  .MuiOutlinedInput-root {
    height: 3rem;
    min-width: ${({ width }) => (width ? `${width}` : '25rem')};
    max-width: ${({ width }) => (width ? `${width}` : '25rem')};
    border-radius: 0.75rem;
    font-size: 1.3rem;
    outline: none;
    padding: 0.25rem;
  }
  .fieldError {
    padding: 0;
    color: red;
    display: flex;
    align-items: center;
    font-size: 1rem;
    flex-wrap: nowrap;
    svg {
      margin-right: 2px;
      font-size: 1rem;
      padding-bottom: 0.1rem;
    }
  }
`;
